cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {

            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };
    //InputNum控件限制类型
    var LIMIT_CATEGORY = {

        "MIN": 0,//最小值
        "MAX": 1//最大值

    };


    var PM_pmc_packagesales_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            viewmodel.get('cMonthDays').setState('min', 1);
            viewmodel.get('cMonthDays').setState('max', 31);
            let mode = viewmodel.getParams().mode;
            let action = viewmodel.getParams().action;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            //viewmodel.get("temporary").setState('defaultSelectedRowIndexes', true);

            viewmodel.get('memberLevelAll').on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            viewmodel.get("combinationsalesmemberlevel").on('afterValueChange', () => {
                displayIsGetmemberPrice(viewmodel);
            })

            /**
             * 套餐价取子件价格之和
             */
            viewmodel.get("mainPriceFromSub").on('afterValueChange', (data) => {

                let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                dealAllocationRule(editRowModels, data.value.value, viewmodel.get('allocationRule').getValue());

                viewmodel.get('allocationRule').setVisible(data.value.value == "false" ? true : false);
                viewmodel.get('allocationRule').setValue(0);

              // 子件价格类型
              viewmodel.get('subPriceType').setVisible(data.value.value == "true" ? true : false);
              viewmodel.get('subPriceType').setValue(0);
              dealSubPriceType(0);
            })

            /**
             * 子件金额分摊规则
             */
            viewmodel.get("allocationRule").on('afterValueChange', (data) => {

                let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                dealAllocationRule(editRowModels, viewmodel.get('mainPriceFromSub').getValue(), data.value.value);

            })

          /**
           * 子件金价格类型
           */
          viewmodel.get("subPriceType").on('afterValueChange', (data) => {
            dealSubPriceType(data.value.value);
          })

          /**
           * 处理子件价格字段逻辑
           * @param  editRowModels
           * @param  isDisabled
           */
          const dealSubPriceType = (subPriceType) => {
            let strategyRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
            let subPriceTypeBoolean = true;
            if ('0' == subPriceType || 0 == subPriceType) {
              subPriceTypeBoolean = false;
            }
            if(!cb.utils.isEmpty(strategyRowModels)) {

              strategyRowModels.forEach(function (item, subPriceType) {
                let productClassType = item.get('productClassType').getValue();
                item.get('combinationProducts').setColumnState('promotionPrice', 'value', null);
                item.get('combinationProducts').setColumnState('promotionPrice', 'visible', subPriceTypeBoolean && productClassType === 1);
              })
            }
          }

            /**
             * 处理底部商品数据逻辑
             */
            viewmodel.get("combinationSalesStrategy").on('afterSetDataSource', function (args) {
              var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
              if(!cb.utils.isEmpty(editRowModels)) {

                editRowModels.forEach(function (item, index) {
                  //分组类型发生变化
                  item.get('strategyItemType').on('afterValueChange', function (data) {
                    handleStrategyItem(this.getParent(), data.value.value);
                    delPro(this.getParent().get('combinationProducts'));
                  })
                  item.get('count').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('minPurchaseCount').setValue(null);
                      this.getParent().get('maxPurchaseCount').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'minPurchaseCount', null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'maxPurchaseCount', null);
                    }
                  })

                  item.get('minPurchaseCount').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('count').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'count', null);
                    }
                  })

                  item.get('maxPurchaseCount').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('count').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'count', null);
                    }
                  })

                  //商品分类发生变化
                  item.get('productClassType').on('afterValueChange', function (data) {
                    handleProductClass(this.getParent(), data.value.value);
                    delPro(item.get('combinationProducts'));
                  })
                })
              }
            })
            /**
             * 处理底部商品数据逻辑
             */
            viewmodel.get("combinationSalesStrategy").on('afterDeleteRows', function (args) {
              var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
              if(!cb.utils.isEmpty(editRowModels)) {

                editRowModels.forEach(function (item, index) {
                  //分组类型发生变化
                  handleStrategyItem(item, item.get('strategyItemType').getValue().value || item.get('strategyItemType').getValue());
                  item.get('strategyItemType').on('afterValueChange', function (data) {
                    handleStrategyItem(this.getParent(), data.value.value);
                  })
                  //商品分类发生变化
                  item.get('productClassType').on('afterValueChange', function (data) {
                    handleProductClass(this.getParent(), data.value.value);
                  })

                  item.get('count').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('minPurchaseCount').setValue(null);
                      this.getParent().get('maxPurchaseCount').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'minPurchaseCount', null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'maxPurchaseCount', null);
                    }

                  })

                  item.get('minPurchaseCount').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('count').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'count', null);
                    }
                  })

                  item.get('maxPurchaseCount').on('afterValueChange', function (data) {
                    if (data.value != null && data.value !== '') {
                      this.getParent().get('count').setValue(null);
                      viewmodel.get('combinationSalesStrategy').setCellValue(index, 'count', null);
                    }
                  })

                  let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                  dealAllocationRule(editRowModels, viewmodel.get('mainPriceFromSub').getValue(), viewmodel.get('allocationRule').getValue());

                  // //处理固定商品只允许选择一个商品
                  // editRowModels.forEach(function (item, index) {
                  //     item.get('combinationProducts').on('beforeInsertRowsFromRefer', function (data1) {
                  //         let isTrue = (this.getParent().get('strategyItemType').getValue() == "1" || this.getParent().get('strategyItemType').getValue().value == "1")
                  //             && (data1.rows != null) && (data1.rows.length > 1);
                  //         if (isTrue) {
                  //             let row1 = data1.rows[0];
                  //             data1.rows.length = 0;
                  //             data1.rows.push(row1);
                  //             cb.utils.alert('固定商品只允许选择一个商品！', 'warning');
                  //         }
                  //     })

                  // })

                  handleProductsBeforeBrowse(item);
                })
              }

            })

            const displayiAreaId = (viewmodel) => {
                cycleDelPro();
                let iRange = viewmodel.get("iRange").getValue();
                //平台
                if (iRange == 0) {
                    // viewmodel.get('btnBatchOp').setVisible(true);
                    viewmodel.get("iAreaId").setVisible(false);
                    viewmodel.get("iAreaId").setValue(null);
                } else {
                    viewmodel.get("iAreaId").setVisible(true);
                    // viewmodel.get('btnBatchOp').setVisible(false);
                }
            }

            viewmodel.get('iAreaId').on('afterValueChange', function (data) {
                common.displayArea(viewmodel);
                cycleDelPro();
            });
            viewmodel.get("iRange").on('afterValueChange', () => {
                displayiAreaId(viewmodel);
            })



            viewmodel.get("mainProduct_Name").on('beforeBrowse', function () {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                let mainProductId = viewmodel.get("mainProductId").getValue();
                //没有选主商品
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };
                if (areaId) {
                    let externalData = {"areaId": areaId};
                    this.setState('externalData', externalData);
                }
                if (!mainProductId) {
                    common.addProductReferCondition(viewmodel, false, condition, null, null, true);

                } else {
                    common.addProductReferCondition(viewmodel, false, condition, null, null, true);
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'eq',
                        value1: mainProductId
                    });
                }
                this.setFilter(condition);
                return true;
            });

            viewmodel.get("iskuId_Name").on('beforeBrowse', function () {
                let areaId;
                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue()) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    } else {
                        areaId = viewmodel.get("iAreaId").getValue();
                    }
                }
                let mainProductSkuId = viewmodel.get("iskuId").getValue();
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };
                if (areaId) {
                    let externalData = {"areaId": areaId};
                    this.setState('externalData', externalData);
                }
                //没有选主商品
                if (!mainProductSkuId) {
                    common.addProductReferCondition(viewmodel, true, condition, null, null, true);
                } else {
                    common.addProductReferCondition(viewmodel, true, condition, null, null, true);
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'eq',
                        value1: mainProductSkuId
                    });
                }
                this.setFilter(condition);
                return true;
            });

            viewmodel.get('mainType').on('afterValueChange', (args) => {
                // if (args.value) {
                //     //商品
                //     if (args.value.value == 1) {
                //         viewmodel.get('iskuId_Name').setValue(null);
                //         viewmodel.get('iskuId_price').setValue(null);
                //         viewmodel.get('skuDescription').setValue(null);
                //         viewmodel.get('iskuId_url').setValue(null);
                //         viewmodel.get("iskuId").setValue(null);
                //         viewmodel.get("iskuId_Code").setValue(null);
                //         viewmodel.get('mainProductId').setValue(null);
                //         viewmodel.get("mainProductCode").setValue(null);
                //     } else {
                //         viewmodel.get('mainProduct_Name').setValue(null);
                //         viewmodel.get('mainProductId_price').setValue(null);
                //         viewmodel.get('mainProductId_modelDescription').setValue(null);
                //         viewmodel.get('mainProductId_url').setValue(null);
                //         viewmodel.get('mainProductId').setValue(null);
                //         viewmodel.get("mainProductCode").setValue(null);
                //     }
                // }
                clearMainType(viewmodel);
                displayMainType(viewmodel);
            })

            viewmodel.on('beforeAddRow', function (args) {

                if (args.params.cTarget == "pmc_goodsss_toolbar_edits") {
                    args.params.childrenField = 'combinationProducts';
                    //在添加之前判断是否为分组类型是否为固定商品，固定商品只允许添加一个商品
                    let index = args.params.params.index;
                    let editRowModel = this.get('combinationSalesStrategy').getCache('editRowModels')[index];
                    let strategyItemType = editRowModel.get('strategyItemType').getValue().value || editRowModel.get('strategyItemType').getValue();
                    let combinationProductsCount = editRowModel.get('combinationProducts').getRowsCount();
                    /*
                     * 选配套餐的固定商品分组中，需要支持添加多行-后台编码任务 2020-12-30 lz
                    if (strategyItemType == 1) {

                        if (combinationProductsCount > 0) {
                            cb.utils.alert("固定商品只允许添加一种商品");
                            return false;
                        }
                    }
                    */
                }
            })

            viewmodel.on('beforeDeleteRow', function (args) {
                let combinationSalesStrategyCount = this.get('combinationSalesStrategy').getRowsCount();
                let isOnlyOneGroup = combinationSalesStrategyCount && combinationSalesStrategyCount == 1 && args.params.params.cItemName == 'btnDeleteRow3';
                if (isOnlyOneGroup) {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }

            });

            viewmodel.get('activityMode').on('afterValueChange', function () {
                common.displayActivityMode(viewmodel);
            });

            viewmodel.get("combinationSalesStrategy").on('afterSetDataSource', function (args) {
                let params = viewmodel.getParams()
                if (params.mode == "browse")
                    common.displayGrandsonBtn(viewmodel, 'combinationSalesStrategy', 'combinationProducts');
            });

            viewmodel.on("modeChange", function (data) {
                mode = data;
                if (data == "browse") {
                    common.displayGrandsonBtn(viewmodel, 'combinationSalesStrategy', 'combinationProducts');
                } else {
                    let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('btnAddRow2').setVisible(true);
                        editRowModels[i].get('btnAddRow3').setVisible(true);
                        editRowModels[i].get('btnDeleteRow3').setVisible(true);
                        let grandsonModel = editRowModels[i].get('combinationProducts');
                        let data = grandsonModel.getData();
                        if (data.length > 0) {
                            let actionsState = [];
                            data.forEach((row, index) => {
                                actionsState.push({
                                    'btnDeleteRow2': {'visible': true}
                                })
                            })
                            grandsonModel.setActionsState(actionsState);
                        }
                    }
                    common.displayChannel(viewmodel, 'packageslaes');
                    common.displayArea(viewmodel);
                }
            })

            viewmodel.on('beforeEdit', function (args) {
                return common.checkAuth(viewmodel.originalParams.id, 'pmc_packagesales');
            })

            viewmodel.on('afterMovenext', function (data) {
                common.displayGrandsonBtn(viewmodel, 'combinationSalesStrategy', 'combinationProducts');
            })

            viewmodel.on('afterMoveprev', function (data) {
                common.displayGrandsonBtn(viewmodel, 'combinationSalesStrategy', 'combinationProducts');
            })

            viewmodel.on('afterLoadData', function (data) {
                viewmodel.get('mainProductId_price').setDisabled(true);
                viewmodel.get('mainProductId_modelDescription').setDisabled(true);
                viewmodel.get('mainProductCode').setDisabled(true);
                viewmodel.get('iskuId_price').setDisabled(true);
                viewmodel.get('skuDescription').setDisabled(true);
                viewmodel.get('iskuId_Code').setDisabled(true);
                common.displayActivityMode(viewmodel);
                common.displayArea(viewmodel);
                common.displayChannel(viewmodel, 'packageslaes');
                common.hideNoStore(viewmodel);

                //处理适用渠道相关逻辑
                dealApplyOnlineChannel();

                if (mode === 'add' && action !== 'copy') {
                    viewmodel.get('combinationSalesStrategy').appendRow({});
                    let editRowModel = viewmodel.get('combinationSalesStrategy').getCache('editRowModels')[0];
                    handleProductsBeforeBrowse(editRowModel);

                } else if (mode === 'edit' || mode === 'browse' || (mode === 'add' && action === 'copy')) {
                    //处理“套餐价取子件价格之和”逻辑
                    let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                    dealAllocationRule(editRowModels, viewmodel.get('mainPriceFromSub').getValue(), viewmodel.get('allocationRule').getValue());

                    //处理分组类型相关业务
                    handleStrategyItemType(data);
                }
                if (viewmodel.get('iskuId').getValue() && viewmodel.get('iskuId').getValue() != 0) {
                    viewmodel.get('mainType').setValue(2);
                } else {
                    viewmodel.get('mainType').setValue(1);
                }
                displayMainType(viewmodel);
                displayMainTypeControl(viewmodel);
                //是否展示会员等级
                displayIsGetmemberPrice(viewmodel);

                if (this.get('applyOnlineChannel').getValue() == false) {
                    viewmodel.get("terminalType").setVisible(false);
                } else {
                    viewmodel.get("terminalType").setVisible(true);
                }

                if (this.get('applyOffLineChannel').getValue() == false) {
                    viewmodel.get('offLineStore').setVisible(false);
                    viewmodel.get('combinationSalesStore').setVisible(false);
                } else {
                    viewmodel.get('offLineStore').setVisible(true);
                    if (this.get('offLineStore').getValue() == 1 || this.get('offLineStore').getValue() == 0) {
                        viewmodel.get('combinationSalesStore').setVisible(false);
                    } else {
                        viewmodel.get('combinationSalesStore').setVisible(true);
                    }
                }

                if (this.get('memberLevelAll').getValue() == 0) {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }

                if (viewmodel.get('mainPriceFromSub').getValue() == true || viewmodel.get('mainPriceFromSub').getValue() == 'true') {
                    viewmodel.get('allocationRule').setVisible(false);
                    if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                      viewmodel.get('subPriceType').setVisible(true);
                    }
                } else {
                    viewmodel.get('subPriceType').setVisible(false);
                }

              let subPriceType = common.convertBooleanToInteger(viewmodel.get('subPriceType').getValue());
              var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
              if(!cb.utils.isEmpty(editRowModels)) {
                editRowModels.forEach(function (item, index) {
                  let productClassType = item.get('productClassType').getValue();
                  item.get('combinationProducts').setColumnState('promotionPrice', 'visible', subPriceType && productClassType === 1);
                  item.get("combinationProducts").on('afterCellValueChange', function (data) {
                    if (data.cellName == 'sProductCode') {
                      this.setCellValue(data.rowIndex, 'sProductSkuName', null);
                      this.setCellValue(data.rowIndex, 'sProductSkuCode', null);
                    }
                  })
                })
              }

            });

            //买家范围控制事件
            viewmodel.get('memberLevelAll').on('afterValueChange', function (data) {
                if (data.value.value === '0') {
                    viewmodel.get("combinationsalesmemberlevel").setVisible(true);
                } else {
                    viewmodel.get('combinationsalesmemberlevel').setVisible(false);
                }
            });
            //线下门店控制事件
            viewmodel.get('offLineStore').on('afterValueChange', function (data) {
                if (data.value.value === '1') {
                    viewmodel.get("combinationSalesStore").setVisible(false);
                } else {
                    viewmodel.get('combinationSalesStore').setVisible(true);
                }
            })

            /**
             * 适用渠道点击事件
             */
            viewmodel.get('applicableChannel').on('afterValueChange', function (data) {
                viewmodel.get('terminalType').setVisible(false);
                viewmodel.get('offLineStore').setVisible(false);
                viewmodel.get('combinationSalesStore').setVisible(false);
                viewmodel.get('applyOnlineChannel').setValue(false);
                viewmodel.get('applyOffLineChannel').setValue(false);
                viewmodel.get('iSendPoint').setVisible(false);
                viewmodel.get('mainPriceFromSub').setDisabled(true);
                viewmodel.get('subProductMustOnSale').setDisabled(true);
                viewmodel.get('allocationRule').setVisible(true);
                var on = 0;
                var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');

                for (var i = 0; i < data.value.length; i++) {
                    if (data.value[i].value == 0) {
                        viewmodel.get('terminalType').setVisible(true);
                        viewmodel.get('applyOnlineChannel').setValue(true);
                        viewmodel.get('iSendPoint').setVisible(false);
                        viewmodel.get('mainPriceFromSub').setDisabled(true);
                        viewmodel.get('subProductMustOnSale').setDisabled(true);

                        editRowModels.forEach(function (item, index) {
                            // item.get('strategyItemType').setValue(1);
                            if ((null != item.get('productClassType').getValue()) && (2 == parseInt(item.get('productClassType').getValue()) || 3 == parseInt(item.get('productClassType').getValue())))  {
                                delPro(item.get('combinationProducts'));
                            }
                            viewmodel.get('combinationSalesStrategy').setRowState(index,'productClassType',1)
                            item.get('productClassType').setValue(1);
                            //分组类型发生变化
                            handleStrategyItem(item, item.get('strategyItemType').getValue().value || item.get('strategyItemType').getValue());

                        })
                        on = 1;
                    } else if (data.value[i].value == 1) {
                        viewmodel.get('applyOffLineChannel').setValue(true);
                        viewmodel.get('offLineStore').setVisible(true);
                        if (viewmodel.get('promotionParams')) {
                            let userType = viewmodel.get('promotionParams').userType;
                            //超级管理员
                            if (userType != 0 && viewmodel.get('offLineStore').getValue() == 1) {
                                viewmodel.get('offLineStore').setValue(2);
                            }
                        }
                        if (viewmodel.get('offLineStore').getValue() == 1) {
                            viewmodel.get('combinationSalesStore').setVisible(false);
                        } else {
                            viewmodel.get('combinationSalesStore').setVisible(true);
                        }
                        if (on == 0) {
                            viewmodel.get('iSendPoint').setVisible(true);
                            viewmodel.get('mainPriceFromSub').setDisabled(false);
                            viewmodel.get('subProductMustOnSale').setDisabled(false);
                            editRowModels.forEach(function (item, index) {
                                // item.get('strategyItemType').setValue(1);
                                //分组类型发生变化
                                handleStrategyItem(item, item.get('strategyItemType').getValue().value || item.get('strategyItemType').getValue());
                            })
                            //如果未选择线上商城，仅选择了线下门店
                            on = 2;
                        }
                    }
                }
                if (on == 2) {
                    //如果未选择线上商城，仅选择了线下门店
                    viewmodel.get('mainPriceFromSub').setDisabled(false);
                    viewmodel.get('subProductMustOnSale').setDisabled(false);
                    viewmodel.get('combinationProducts').setColumnState('iProductNum', 'visible', false);
                } else {
                    viewmodel.get('mainPriceFromSub').setDisabled(true);
                    viewmodel.get('subProductMustOnSale').setDisabled(true);
                    let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                    //将“套餐价取子件价格之和”字段重置为false
                    viewmodel.get('mainPriceFromSub').setValue(false);
                    viewmodel.get('subProductMustOnSale').setValue(false);
                    viewmodel.get('allocationRule').setValue(0);

                    dealAllocationRule(editRowModels, viewmodel.get('mainPriceFromSub').getValue(), viewmodel.get('allocationRule').getValue());
                  // 子件价格类型
                  viewmodel.get('subPriceType').setVisible(viewmodel.get('mainPriceFromSub').getValue() == "true" ? true : false);
                  viewmodel.get('subPriceType').setValue(0);
                  dealSubPriceType(0);
                  viewmodel.get('combinationProducts').setColumnState('iProductNum', 'visible', false);

                }
                displayMainTypeControl(viewmodel);
                clearMainType(viewmodel);
            });

            viewmodel.get("combinationSalesStrategy").on('afterCellValueChange', function (data) {
              debugger;
            })
            /**
             * 增组按钮处理
             */
            viewmodel.get('combinationSalesStrategy').on('afterInsertRow', function (args) {

                var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                if (null != editRowModels) {

                  editRowModels.forEach(function (item, index) {

                    //分组类型发生变化
                    handleStrategyItem(item, item.get('strategyItemType').getValue().value || item.get('strategyItemType').getValue());
                    item.get('strategyItemType').on('afterValueChange', function (data) {
                      handleStrategyItem(this.getParent(), data.value.value);
                      delPro(item.get('combinationProducts'));
                    })

                    item.get('count').on('afterValueChange', function (data) {
                      if ((data.value.value != null && data.value.value !== '') || data.value !== '') {
                        this.getParent().get('minPurchaseCount').setValue(null);
                        this.getParent().get('maxPurchaseCount').setValue(null);
                      }
                    })

                    item.get('minPurchaseCount').on('afterValueChange', function (data) {
                      if ((data.value.value != null && data.value.value !== '') || data.value !== '') {
                        this.getParent().get('count').setValue(null);
                      }
                    })

                    item.get('maxPurchaseCount').on('afterValueChange', function (data) {
                      if ((data.value.value != null && data.value.value !== '') || data.value !== '') {
                        this.getParent().get('count').setValue(null);
                      }
                    })

                    //商品分类发生变化
                    item.get('productClassType').on('afterValueChange', function (data) {
                      handleProductClass(this.getParent(), data.value.value);
                      delPro(item.get('combinationProducts'));
                    })

                    let editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                    dealAllocationRule(editRowModels, viewmodel.get('mainPriceFromSub').getValue(), viewmodel.get('allocationRule').getValue());

                    if(!cb.utils.isEmpty(editRowModels)) {

                      //处理固定商品只允许选择一个商品
                      editRowModels.forEach(function (item, index) {
                        item.get('combinationProducts').on('beforeInsertRowsFromRefer', function (data1) {
                          let isTrue = (this.getParent().get('strategyItemType').getValue() == "1" || this.getParent().get('strategyItemType').getValue().value == "1")
                            && (data1.rows != null) && (data1.rows.length > 1);
                          if (isTrue) {
                            let row1 = data1.rows[0];
                            data1.rows.length = 0;
                            data1.rows.push(row1);
                            cb.utils.alert('固定商品只允许选择一个商品！', 'warning');
                          }
                        })

                      })
                    }

                    handleProductsBeforeBrowse(item);

                  })
                }

            })


            viewmodel.get("mainProduct_Name").on('beforeValueChange', args => {
                common.mainURL(args, false);
            });

            viewmodel.get("iskuId_Name").on('beforeValueChange', args => {
                common.mainURL(args, true);
            });

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);


                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                obj.activityType = setCheckBoxEnum(obj.activityType);
                obj.cMonthDays = String(obj.cMonthDays);

                if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                    if (!viewmodel.get("iAreaId").getValue() || viewmodel.get("iAreaId").getValue() == 0) {
                        cb.utils.alert('请选择适用区域', 'warning');
                        return false;
                    }
                }

                if (!viewmodel.get("iskuId").getValue() && !viewmodel.get("mainProductId").getValue()) {
                    cb.utils.alert('请选择主商品', 'warning');
                    return false;
                }

                if (this.get('applyOnlineChannel').getValue() == '1' && obj.terminalType == 0) {
                    cb.utils.alert('适用线上商城时，适用终端不可为空', 'warning');
                    return false;
                }

                if (this.get('memberLevelAll').getValue() == '0' && this.get('combinationsalesmemberlevel').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('memberLevelAll').getValue() != '0') {
                    obj.combinationsalesmemberlevel = [];
                }

                if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() != '1' && this.get('combinationSalesStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('applyOffLineChannel').getValue() == '0') {
                    obj.offLineStore = 1;
                    if (obj.memberLevelAll == 1) {
                        obj.memberLevelAll = 2;
                    }
                } else if (this.get('applyOffLineChannel').getValue() == '1' && this.get('offLineStore').getValue() == '1') {
                    obj.combinationSalesStore = [];
                }
                if (this.get('cMonthDays').getValue() && this.get('cMonthDays').getValue() != '') {
                    obj.cMonthDays = ',' + obj.cMonthDays + ',';
                }

                if (this.get('cWeekDays').getValue() && this.get('cWeekDays').getValue() != '') {
                    obj.cWeekDays = ',' + obj.cWeekDays + ',';
                }
                //每天、每周、每月活动时间控制
                if (this.get('activityMode').getValue() == 1) {
                    if (!this.get('beginTime').getValue() || !this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('beginTime').getValue() >= this.get('endTime').getValue()) {
                        cb.utils.alert('每天活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 2) {
                    if (!this.get('cWeekBeginTime').getValue() || !this.get('cWeekEndTime').getValue() || !this.get('cWeekDays').getValue()) {
                        cb.utils.alert('每周活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cWeekBeginTime').getValue() >= this.get('cWeekEndTime').getValue()) {
                        cb.utils.alert('每周活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                } else if (this.get('activityMode').getValue() == 3) {
                    if (!this.get('cMonthDays').getValue() || !this.get('cMonthBeginTime').getValue() || !this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动时间不能为空', 'warning');
                        return false;
                    }
                    if (this.get('cMonthBeginTime').getValue() >= this.get('cMonthEndTime').getValue()) {
                        cb.utils.alert('每月活动开始时间必须小于结束时间', 'warning');
                        return false;
                    }
                }

                //处理子孙表中数据相关信息验证
                let editRowModels = viewmodel.get('combinationSalesStrategy').getRows();
                let mainPriceFromSub = this.get('mainPriceFromSub').getValue();
                let allocationRule = this.get('allocationRule').getValue();
                //金额权重总和
                var porpotionSum = 0;
                //是否停止下一步操作
                var isStop = false;
                if (editRowModels.length == 0) {
                    cb.utils.alert('最少设置一个分组', 'warning');
                    isStop = true;
                }
                editRowModels.forEach(function (item, index) {

                    //判断各个分组是否有数据信息
                    if (item.combinationProducts == null || item.combinationProducts.length == 0) {
                        var productClassType = item.productClassType;
                        switch(parseInt(productClassType)) {
                            case 1:
                                    cb.utils.alert("分组商品信息不能为空" /* "分组商品信息不能为空" */, 'warning');
                                break;
                            case 2:
                                    cb.utils.alert("分组商品分类信息不能为空", 'warning');
                                break;
                            case 3:
                                    cb.utils.alert("分组标签信息不能为空", 'warning');
                                break;
                            default:
                                break;
                        }
                        isStop = true;
                        return false;
                    }


                    let temp = false;
                    let count = 0;
                    if (1 == item.strategyItemType || 1 == parseInt(item.productClassType)) {
                        item.combinationProducts.forEach(function (pro, i) {
                            if (pro._status == "Delete") return;
                            count++;
                            let isTrue = viewmodel.get('mainProductId').getValue() && viewmodel.get('mainProductShop').getValue() != 0 && pro.iShopId != viewmodel.get('mainProductShop').getValue()
                            if (isTrue) {
                                cb.utils.alert('第' + (index + 1) + '组第' + count + '行商品与主商品的商家不符，请选择同一商家的商品', 'warning');
                                temp = true;
                                return false;
                            }
                            if (common.checkNull(pro.sProductSkuCode)) {
                                cb.utils.alert('请输入第' + (index + 1) + '组第' + count + '行的SKU编码不能为空', 'warning');
                                isStop = true;
                                return false;
                            }
                        })
                    }

                    if (count == 0 && (1 == item.strategyItemType || 1 == parseInt(item.productClassType))) {
                        cb.utils.alert('分组商品信息不能为空', 'warning');
                        isStop = true;
                        return false;
                    }
                    if (temp) {
                        isStop = true;
                        return false;
                    }

                    let productClassCount = 0;
                    if (null != item.productClassType && (2 == parseInt(item.productClassType) ||  3 == parseInt(item.productClassType))) {
                        item.combinationProducts.forEach(function (pro, i) {
                            if (pro._status == "Delete") return;
                            productClassCount++;
                            if (common.checkNull(pro.productClassId) && 2 == parseInt(item.productClassType)) {
                                cb.utils.alert('请选择第' + (index + 1) + '组第' + productClassCount + '行的商品分类', 'warning');
                                isStop = true;
                                return false;
                            }
                            if (common.checkNull(pro.tagId) && 3 == parseInt(item.productClassType)) {
                                cb.utils.alert('请选择第' + (index + 1) + '组第' + productClassCount + '行的商品标签', 'warning');
                                isStop = true;
                                return false;
                            }
                        })
                    }
                    if (productClassCount == 0 && (2 == parseInt(item.productClassType))) {
                        cb.utils.alert('分组商品分类不能为空', 'warning');
                        isStop = true;
                        return false;
                    }
                    if (productClassCount == 0 && (3 == parseInt(item.productClassType))) {
                        cb.utils.alert('分组商品标签不能为空', 'warning');
                        isStop = true;
                        return false;
                    }
                    if (isStop) {
                        return false;
                    }

                    if (mainPriceFromSub == false || mainPriceFromSub == 'false') {
                        if (allocationRule == 0 || allocationRule == '0') {
                            if (item.proportion == null) {
                                cb.utils.alert('第' + (index + 1) + '组的金额权重不能为空', 'warning');
                                isStop = true;
                                return false;
                            }
                        } else if (allocationRule == 1 || allocationRule == '1') {
                            if (item.priority == null) {
                                cb.utils.alert('第' + (index + 1) + '组的优先级不能为空', 'warning');
                                isStop = true;
                                return false;
                            }
                            if (item.priority < 1) {
                                cb.utils.alert('第' + (index + 1) + '组的优先级不能小于1', 'warning');
                                isStop = true;
                                return false;
                            }
                        }

                    }
                    //if (1 == parseInt(item.productClassType)) {
                        switch (parseInt(item.strategyItemType)) {
                            case 1:
                                count = 0;
                                item.combinationProducts.forEach(function (pro, i) {
                                    if (pro._status == "Delete") return;
                                    count++;
                                    if (common.checkNull(pro.iProductNum)) {
                                        cb.utils.alert('请输入第' + (index + 1) + '组第' + count + '行的数量', 'warning');
                                        isStop = true;
                                        return false;
                                    }

                                    if (pro.iProductNum == 0) {
                                        cb.utils.alert('数量不能为0', 'warning');
                                        isStop = true;
                                        return false;
                                    }
                                })
                                break;
                            case 2:

                                if (common.checkNull(item.strategyItemName)) {
                                    cb.utils.alert('分组名称不能为空', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                if (common.checkNull(item.count) && common.checkNull(item.minPurchaseCount) && common.checkNull(item.maxPurchaseCount)) {
                                    cb.utils.alert('第' + (index + 1) + '组的指定可选商品数量、最少购买数量、最多购买数量不能都为空', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                if (!common.checkNull(item.minPurchaseCount) && !common.checkNull(item.maxPurchaseCount)) {
                                    if (item.minPurchaseCount >= item.maxPurchaseCount) {
                                      cb.utils.alert('第' + (index + 1) + '组的指定最少购买数量不能大于最多购买数量', 'warning');
                                      isStop = true;
                                      return false;
                                    }
                                }
                                if (!common.checkNull(item.proportion) && common.checkNull(item.minPurchaseCount) && !common.checkNull(item.maxPurchaseCount)) {
                                  cb.utils.alert('第' + (index + 1) + '组的最少购买数量不能都为空', 'warning');
                                  isStop = true;
                                  return false;
                                }
                                if (item.count == 0) {
                                    cb.utils.alert('第' + (index + 1) + '组的指定可选商品数量不能为0', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                if (item.minPurchaseCount == 0) {
                                    cb.utils.alert('第' + (index + 1) + '组的指最少购买数量不能为0', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                break;
                            case 3:
                                if (common.checkNull(item.strategyItemName)) {
                                    cb.utils.alert('第' + (index + 1) + '组的分组名称不能为空', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                if (common.checkNull(item.price)) {
                                    cb.utils.alert('第' + (index + 1) + '组的指定可选商品金额不能为空', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                if (item.price == 0) {
                                    cb.utils.alert('第' + (index + 1) + '组的指定可选商品金额不能为0', 'warning');
                                    isStop = true;
                                    return false;
                                }
                                break;
                            default:
                                break;
                        }
                    //}
                  let subPriceType = viewmodel.get('subPriceType').getValue() == 1 || viewmodel.get('subPriceType').getValue() == '1';

                  // 校验促销价
                  if (subPriceType && 1 == item.productClassType) {
                    item.combinationProducts.forEach(function (pro, rowIndex) {
                      if (pro.promotionPrice == null) {
                        cb.utils.alert('请输入第' + (index + 1) + '组第' +(rowIndex + 1) + '行的促销价', 'warning');
                        isStop = true;
                        return false;
                      }
                    })
                  }

                    //判断金额权重总额是否为100
                    if (mainPriceFromSub == false || mainPriceFromSub == 'false') {
                        if (allocationRule == 0 || allocationRule == '0') {
                            let proportion = item.proportion;
                            if (proportion == null) {
                                cb.utils.alert('第' + (index + 1) + '组的金额权重不能为空', 'warning');
                                isStop = true;
                                return false;
                            }
                            if (proportion != 0) {
                                porpotionSum += proportion;
                            }
                        }
                    }
                })
                //如果参数验证出现问题，直接终止
                if (isStop) return false;

                if ((this.get('mainPriceFromSub').getValue() == false || this.get('mainPriceFromSub').getValue() == "false") && (allocationRule == 0 || allocationRule == '0') && porpotionSum != 100) {
                    cb.utils.alert('金额权重总和应为100', 'warning');
                    return false;
                }

                // if (mode == 'add') {
                //     if (viewmodel.get('startDate').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (this.get('startDate').getValue() >= this.get('endDate').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (obj.mainProductId != null && obj.mainProductId_price != null) {
                    obj.PackageDiscountDrice = obj.mainProductId_price;
                }
                if (obj.combinationSalesStrategy) {
                    obj.combinationSalesStrategy.forEach(function (strategy, i) {
                        if (obj.allocationRule == 0 || obj.allocationRule == '0') {
                            strategy.priority = null;
                        } else if (obj.allocationRule == 1 || obj.allocationRule == '1') {
                            strategy.proportion = null;
                        }
                    });
                }

                data.data.data = JSON.stringify(obj);

            })
            /**
             * 处理分组类型相关业务
             * @param data
             */
            const handleStrategyItemType = (data) => {
                let combinationSalesStrategy = data.combinationSalesStrategy;

                combinationSalesStrategy.forEach(function (item, index) {
                    let editRowModel = viewmodel.get('combinationSalesStrategy').getCache('editRowModels')[index];
                    handleStrategyItem(editRowModel, item.strategyItemType);
                  if(!cb.utils.isEmpty(editRowModel)) {

                    //处理固定商品只允许选择一个商品
                    editRowModel.get('combinationProducts').on('beforeInsertRowsFromRefer', function (data1) {
                      let isTrue = (this.getParent().get('strategyItemType').getValue() == "1" || this.getParent().get('strategyItemType').getValue().value == "1")
                        && (data1.rows != null) && (data1.rows.length > 1);
                      if (isTrue) {
                        let row1 = data1.rows[0];
                        data1.rows.length = 0;
                        data1.rows.push(row1);
                        cb.utils.alert('固定商品只允许选择一个商品！', 'warning');
                      }
                    })
                  }
                    handleProductsBeforeBrowse(editRowModel);
                })
            }

            /**
             * 处理金额权重字段逻辑
             * @param  editRowModels
             * @param  isDisabled
             */
            const dealAllocationRule = (editRowModels, mainPriceFromSub, allocationRule) => {
                if (mainPriceFromSub == "false" || mainPriceFromSub == false) {
                    if (allocationRule == "0" || allocationRule == 0) {
                        isDisabledProportion(editRowModels, false);
                        isDisabledPriority(editRowModels, true);
                    } else if (allocationRule == "1" || allocationRule == 1) {
                        isDisabledProportion(editRowModels, true);
                        isDisabledPriority(editRowModels, false);
                    }
                } else {
                    isDisabledProportion(editRowModels, true);
                    isDisabledPriority(editRowModels, true);
                }
            }

            /**
             * 处理金额权重字段逻辑
             * @param  editRowModels
             * @param  isDisabled
             */
            const isDisabledProportion = (editRowModels, isDisabled) => {
                if (editRowModels != null) {
                    editRowModels.forEach(function (item, index) {
                        if (isDisabled) {
                            item.get('proportion').clear();
                        }
                        item.get('proportion').setDisabled(isDisabled);
                    })
                }

            }

            /**
             * 处理优先级字段逻辑
             * @param  editRowModels
             * @param  isDisabled
             */
            const isDisabledPriority = (editRowModels, isDisabled) => {
                if (editRowModels != null) {
                    editRowModels.forEach(function (item, index) {
                        if (isDisabled) {
                            item.get('priority').clear();
                        }
                        item.get('priority').setDisabled(isDisabled);
                    })
                }

            }

            /**
             * 设置控件最大最小值
             * @param view 控件
             * @param limitCategory 限制类型
             * @param limitNum 限制值
             */
            const setViewLimit = (view, limitCategory, limitNum) => {
                if (limitCategory == LIMIT_CATEGORY.MAX) {
                    view.setState('max', limitNum);
                } else {
                    view.setState('min', limitNum);
                }
            }

            /**
             * 处理适用渠道相关逻辑
             * @param viewmodel
             */
            const dealApplyOnlineChannel = () => {
                if (viewmodel.get('applyOnlineChannel').getValue() == 0 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(true);
                    viewmodel.get('mainPriceFromSub').setDisabled(false);
                    viewmodel.get('subProductMustOnSale').setDisabled(false);
                    viewmodel.get('applicableChannel').setValue(["1"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 0) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('mainPriceFromSub').setDisabled(true);
                    viewmodel.get('subProductMustOnSale').setDisabled(true);
                    viewmodel.get('applicableChannel').setValue(["0"]);
                } else if (viewmodel.get('applyOnlineChannel').getValue() == 1 && viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get('iSendPoint').setVisible(false);
                    viewmodel.get('mainPriceFromSub').setDisabled(true);
                    viewmodel.get('subProductMustOnSale').setDisabled(true);
                    viewmodel.get('applicableChannel').setValue(["0", "1"]);
                }
                ;

            }

            /**
             * 处理子表商品选择问题
             * @param  editRowModel
             */
            const handleProductsBeforeBrowse = (editRowModel) => {
                editRowModel.get("combinationProducts").on("beforeBrowse", function (data) {
                    if ("cTagName" == data.cellName || "productClassName" == data.cellName) {
                        return;
                    }
                    let areaId;
                    if (viewmodel.get("iRange") && viewmodel.get("iRange").getValue() == 1) {
                        if (!viewmodel.get("iAreaId").getValue()) {
                            cb.utils.alert('请选择适用区域', 'warning');
                            return false;
                        } else {
                            areaId = viewmodel.get("iAreaId").getValue();
                        }
                    }

                    let condition = {
                        "isExtend": true,
                        simpleVOs: []
                    };
                    let rowIndex = data.rowIndex;
                    let banProducts = "";
                    let currentPreferentialPro = '';
                    if (this.getRows()[rowIndex].sProductSkuCode != null) {
                        currentPreferentialPro = this.getRows()[rowIndex].sProductSkuCode;
                    }

                    //商品参照
                    //当前行选了商品
                    if (currentPreferentialPro && currentPreferentialPro != '') {
                        condition.simpleVOs.push({
                            field: 'code',
                            op: 'in',
                            value1: currentPreferentialPro.split(',')
                        });
                    } else {
                        //排除当前行选择的sku
                        //当前行没有选择商品，需要排除其他行选择的商品
                        viewmodel.get('combinationSalesStrategy').getCache('editRowModels').forEach(function (item, i) {
                            let editRowModel = item.get('combinationProducts').getRows();
                            if (editRowModel != null) {
                                editRowModel.forEach(function (item, i) {
                                    if (item != null) {
                                        if (item.sProductSkuCode && item.sProductSkuCode != '') {
                                            if(!cb.utils.isEmpty(item.sProductSkuCode)){
                                                banProducts += item.sProductSkuCode;
                                                banProducts += ",";
                                            }
                                        }
                                    }
                                })
                            }

                        });

                    }
                    //排除主商品
                    // let mainProductCode = viewmodel.get("mainProductCode").getValue();
                    // if (mainProductCode) {
                    //     banProducts += mainProductCode;
                    //     banProducts += ",";
                    // }
                    // if (banProducts != "") {
                    //     banProducts.substring(0, banProducts.length - 1);
                    // }
                    let orConditions = [];
                    //查某个字段不等于某个值时，平台会在这个字段不为null的基础条件上去过滤
                    orConditions.push({
                        field: 'productId.virtualProductAttribute',
                        op: 'neq',
                        value1: 9
                    });
                    orConditions.push({
                        field: 'productId.virtualProductAttribute',
                        op: 'is_null',
                    })
                    condition.simpleVOs.push({
                        "logicOp": "or",
                        "conditions": orConditions
                    });
                    common.addProductReferCondition(viewmodel, true, condition, banProducts == ""
                        ? null : banProducts.split(","), null, false);
                    let externalData = {};
                    if (areaId) {
                        externalData.areaId = areaId;
                    }
                    if (viewmodel.get("memberLevelAll").getValue() == 0 && viewmodel.get("isGetmemberPrice").getValue()
                        && viewmodel.get("combinationsalesmemberlevel").getShowValue() && viewmodel.get("combinationsalesmemberlevel").getShowValue().length > 0) {
                        externalData.memberLevelId = viewmodel.get("combinationsalesmemberlevel").getValue()[0]["lMemberLeverId"];
                        externalData.memberLevelId = null;
                        externalData.iProductType = 1;
                    }
                    if(!cb.utils.isEmptyObject(externalData)){
                        data.context.setState('externalData', externalData);
                    }
                    data.context.setFilter(condition);

                    return true;
                })
            }

            /**
             * 是否展示“取会员价作为商品原价”
             * @param viewmodel
             */
            const displayIsGetmemberPrice = (viewmodel) => {
                if (viewmodel.get("memberLevelAll").getValue() == 0 && viewmodel.get("combinationsalesmemberlevel").getShowValue()
                    && viewmodel.get("combinationsalesmemberlevel").getShowValue().length == 1) {
                    viewmodel.get("isGetmemberPrice").setDisabled(false);
                } else {
                    viewmodel.get("isGetmemberPrice").setValue(false);
                    viewmodel.get("isGetmemberPrice").setDisabled(true);
                }
            }

            const delPro = (editRowModel) => {
                if (editRowModel.getRows() && editRowModel.getRows().length > 0) {
                    let counts = editRowModel.getRowsCount();
                    var rowIndexes = [];
                    for (let i = counts - 1; i >= 0; i--) {
                        rowIndexes.push(i);
                    }
                    editRowModel.deleteRows(rowIndexes);
                }
            }

            const cycleDelPro = () => {
                var editRowModels = viewmodel.get('combinationSalesStrategy').getCache('editRowModels');
                if(!cb.utils.isEmpty(editRowModels)){
                    editRowModels.forEach(function (item, index) {
                        delPro(item.get('combinationProducts'));
                    })
                }
            }

            /**
             * 处理不同分组类型，相应字段显示问题
             * @param  editRowModel
             * @param  value
             */
            const handleStrategyItem = (editRowModel, value) => {

                // setViewLimit(editRowModel.get('combinationProducts').getEditRowModel().get('iProductNum'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('proportion'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('proportion'), LIMIT_CATEGORY.MAX, 100);
                setViewLimit(editRowModel.get('count'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('minPurchaseCount'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('maxPurchaseCount'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('price'), LIMIT_CATEGORY.MIN, 0);
                setViewLimit(editRowModel.get('priority'), LIMIT_CATEGORY.MIN, 1);
                editRowModel.get('combinationProducts').setState('showColumnSetting', false);
                var applicableChannel = viewmodel.get('applicableChannel').getValue() || [];

                switch (parseInt(value)) {
                    case 1:
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').setState('multiple', false);
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').clearCache('vm');
                        editRowModel.get('strategyItemName').setVisible(false);
                        editRowModel.get('count').setVisible(false);
                        editRowModel.get('minPurchaseCount').setVisible(false);
                        editRowModel.get('maxPurchaseCount').setVisible(false);
                        editRowModel.get('price').setVisible(false);
                        editRowModel.get('productClassType').setVisible(false);
                        editRowModel.get('combinationProducts').setColumnState('iProductNum', 'cShowCaption', '数量');
                        editRowModel.get('combinationProducts').setColumnState('cTagName', 'visible', false);
                        editRowModel.get('combinationProducts').setColumnState('productClassName', 'visible', false);
                        handleCombinationProductsIsShow(editRowModel, true);
                        break;
                    case 2:
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').setState('multiple', true);
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').clearCache('vm');
                        editRowModel.get('strategyItemName').setVisible(true);
                        editRowModel.get('count').setVisible(true);
                        editRowModel.get('minPurchaseCount').setVisible((applicableChannel.indexOf("1") > -1) && !(applicableChannel.indexOf('0') > -1));
                        editRowModel.get('maxPurchaseCount').setVisible((applicableChannel.indexOf("1") > -1) && !(applicableChannel.indexOf('0') > -1));
                        editRowModel.get('price').setVisible(false);
                        editRowModel.get('productClassType').setVisible((applicableChannel.indexOf("1") > -1) && !(applicableChannel.indexOf('0') > -1));
                        editRowModel.get('combinationProducts').setColumnState('iProductNum', 'cShowCaption', '最大选购数量(仅适用线上)');
                        handleProductClass(editRowModel, editRowModel.get('productClassType').getValue(), applicableChannel.indexOf("1") > -1 && !(applicableChannel.indexOf('0') > -1));
                        break;
                    case 3:
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').setState('multiple', true);
                        editRowModel.get('combinationProducts').getEditRowModel().get('sProductSkuCode').clearCache('vm');
                        editRowModel.get('strategyItemName').setVisible(true);
                        editRowModel.get('count').setVisible(false);
                        editRowModel.get('minPurchaseCount').setVisible(false);
                        editRowModel.get('maxPurchaseCount').setVisible(false);
                        editRowModel.get('price').setVisible(true);
                        editRowModel.get('productClassType').setVisible((applicableChannel.indexOf("1") > -1) && !(applicableChannel.indexOf('0') > -1));
                        editRowModel.get('combinationProducts').setColumnState('iProductNum', 'cShowCaption', '最大选购数量(仅适用线上)');
                        handleProductClass(editRowModel, editRowModel.get('productClassType').getValue(), applicableChannel.indexOf("1") > -1 && !(applicableChannel.indexOf('0') > -1));
                      break;
                    default:
                        break;
                }
            }

            /**
             * 处理商品分类
             * @param {*} editRowModel
             * @param {*} value
             */
            const handleProductClass = (editRowModel, productClassValue, isOffline) => {
                if (1 == productClassValue) {
                    editRowModel.get('combinationProducts').setColumnState('cTagName', 'visible', false);
                    editRowModel.get('combinationProducts').setColumnState('productClassName', 'visible', false);
                    handleCombinationProductsIsShow(editRowModel, true, isOffline);
                } else if (2 == productClassValue) {
                    editRowModel.get('combinationProducts').setColumnState('cTagName', 'visible', false);
                    editRowModel.get('combinationProducts').setColumnState('productClassName', 'visible', true);
                    handleCombinationProductsIsShow(editRowModel, false);
                } else if (3 == productClassValue) {
                    editRowModel.get('combinationProducts').setColumnState('cTagName', 'visible', true);
                    editRowModel.get('combinationProducts').setColumnState('productClassName', 'visible', false);
                    handleCombinationProductsIsShow(editRowModel, false);
                }

            }

            const handleCombinationProductsIsShow = (editRowModel, isShow, isOffline) => {

              editRowModel.get('combinationProducts').setColumnState('productName', 'visible', isShow);
              editRowModel.get('combinationProducts').setColumnState('sProductSkuCode', 'visible', isShow);
              editRowModel.get('combinationProducts').setColumnState('skuDescription', 'visible', isShow);
              editRowModel.get('combinationProducts').setColumnState('price', 'visible', isShow);
              if (null != isOffline) {
                editRowModel.get('combinationProducts').setColumnState('iProductNum', 'visible', !isOffline);
              } else {
                editRowModel.get('combinationProducts').setColumnState('iProductNum', 'visible', isShow);
              }
              let subPriceType = parseInt(viewmodel.get('subPriceType').getValue());
              let productClassType = editRowModel.get('productClassType').getValue();
              editRowModel.get('combinationProducts').setColumnState('promotionPrice', 'visible', isShow && subPriceType == 1 && productClassType == 1);

            }

            const displayMainType = (viewmodel) => {
                let mainType = viewmodel.get("mainType").getValue();
                //商品
                if (mainType == 1) {
                    viewmodel.get('mainProduct_Name').setVisible(true);
                    viewmodel.get('mainProductId_price').setVisible(true);
                    viewmodel.get('mainProductId_modelDescription').setVisible(true);
                    viewmodel.get('mainProductId_url').setVisible(true);
                    viewmodel.get('mainProductCode').setVisible(true);
                    viewmodel.get('iskuId_Name').setVisible(false);
                    viewmodel.get('iskuId_price').setVisible(false);
                    viewmodel.get('skuDescription').setVisible(false);
                    viewmodel.get('iskuId_url').setVisible(false);
                    viewmodel.get('iskuId_Code').setVisible(false);
                } else {
                    viewmodel.get('mainProduct_Name').setVisible(false);
                    viewmodel.get('mainProductId_price').setVisible(false);
                    viewmodel.get('mainProductId_modelDescription').setVisible(false);
                    viewmodel.get('mainProductId_url').setVisible(false);
                    viewmodel.get('mainProductCode').setVisible(false);
                    viewmodel.get('iskuId_Name').setVisible(true);
                    viewmodel.get('iskuId_price').setVisible(true);
                    viewmodel.get('skuDescription').setVisible(true);
                    viewmodel.get('iskuId_url').setVisible(true);
                    viewmodel.get('iskuId_Code').setVisible(true);
                }
            }

            const displayMainTypeControl = (viewmodel) => {
                if (viewmodel.get('applyOffLineChannel').getValue() == 1) {
                    viewmodel.get("mainType").setVisible(false);
                } else {
                    viewmodel.get("mainType").setVisible(true);
                }
            }

            const clearMainType = (viewmodel) => {
                viewmodel.get('iskuId_Name').setValue(null);
                viewmodel.get('iskuId_price').setValue(null);
                viewmodel.get('skuDescription').setValue(null);
                viewmodel.get('iskuId_url').setValue(null);
                viewmodel.get("iskuId").setValue(null);
                viewmodel.get("iskuId_Code").setValue(null);
                viewmodel.get('mainProductId').setValue(null);
                viewmodel.get("mainProductCode").setValue(null);
                viewmodel.get('mainProduct_Name').setValue(null);
                viewmodel.get('mainProductId_price').setValue(null);
                viewmodel.get('mainProductId_modelDescription').setValue(null);
                viewmodel.get('mainProductId_url').setValue(null);
            }

        }

    };
    try {
        module.exports = PM_pmc_packagesales_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_packagesales_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_packagesales_VM.Extend.js